import { Box, Typography } from '@mui/material';
import PieChart from '../components/PieChart';
import { useGraficas } from '../hooks/useGraficas';
import { useEffect } from 'react';


export const Sponsor = () => {

    const { añoAbonos, setAñoAbonos, mesAbonos, setMesAbonos, datosAbonos, currentYearAbonos, getAbonosTipo } = useGraficas();


    useEffect(() => {
        getAbonosTipo()
            .then(data => {
                console.log('Datos de movimientos mensuales:', data);
            })
            .catch(err => {
                console.error('Error al obtener los movimientos mensuales:', err);
            });
    }
        , [currentYearAbonos, mesAbonos]);


    return (
        <Box textAlign="center" display="flex" alignItems="center" flexDirection='column' >
            <Typography variant="h4" component="div" gutterBottom marginY='1em'>
                Ingreso por Tipo de Cobro
            </Typography>
            <Typography component="div" textAlign='left' width={'100%'} style={{ textIndent: '2rem' }} marginY='0.5em'>
                Mostrar Año:
                <select
                    value={añoAbonos}
                    style={{
                        fontSize: '1rem',
                        padding: '0.5em',
                        borderRadius: '5px',
                        border: '1px solid #AAA',
                        margin: '0.5em',
                        width: '6em'
                    }}
                    onChange={(e) => {
                        const year = e.target.value;
                        setAñoAbonos(`${year}`);
                        setMesAbonos('01');
                        console.log(`Año seleccionado: ${year}`);
                    }}
                >
                    {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - 5 + i).map(year => (
                        <option key={year} value={year}>{year}</option>
                    ))}
                </select>
                Mostrar Mes:
                <select
                    value={mesAbonos}
                    style={{
                        fontSize: '1rem',
                        padding: '0.5em',
                        borderRadius: '5px',
                        border: '1px solid #AAA',
                        margin: '0.5em',
                        width: '8em'
                    }}
                    onChange={(e) => {
                        const month = e.target.value;
                        setMesAbonos(month);
                        console.log(`Mes seleccionado: ${month}`);
                    }}
                >
                    {(() => {
                        const currentYear = new Date().getFullYear();
                        const currentMonth = new Date().getMonth();
                        const selectedYear = Number(añoAbonos);
                        const months = [
                            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
                        ];
                        let maxMonth = 11;
                        if (selectedYear === currentYear) {
                            maxMonth = currentMonth;
                        }
                        return months.slice(0, maxMonth + 1).map((month, idx) => (
                            <option key={idx + 1} value={idx + 1}>{month}</option>
                        ));
                    })()}
                </select>
            </Typography>

            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                width="clamp(75%, 50vw, 10%)"
                maxWidth={600}
                paddingBottom="10rem"
            >
                <PieChart
                    camposDatos='cargo'
                    campoTitulo='tipo'
                    dataObject={datosAbonos}
                    tituloValor='Movimiento Mensual Q. '
                />
            </Box>

        </Box>
    );



}